import {
    startOfWeek,
    endOfWeek,
    startOfMonth,
    endOfMonth,
    startOfQuarter,
    endOfQuarter,
    startOfYear,
    endOfYear,
    subWeeks,
    subMonths,
    subQuarters,
    subDays,
    addWeeks,
    format
} from 'date-fns';

export interface DateRange {
    startDate: string;
    endDate: string;
}

// Helper function to determine if a period is future-focused
export const isFuturePeriod = (period: string): boolean => {
    return period === 'This week' || period === 'Next 2 weeks';
};

export const getDateRange = (period: string): DateRange => {
    const today = new Date();
    let startDate: Date;
    let endDate: Date;

    switch (period) {
        // Week options
        case 'This week':
            startDate = startOfWeek(today, { weekStartsOn: 0 }); // Sunday
            endDate = endOfWeek(today, { weekStartsOn: 0 });
            break;

        case 'Previous week':
            const prevWeek = subWeeks(today, 1);
            startDate = startOfWeek(prevWeek, { weekStartsOn: 0 });
            endDate = endOfWeek(prevWeek, { weekStartsOn: 0 });
            break;

        case 'Next 2 weeks':
            startDate = today;
            endDate = addWeeks(today, 2);
            break;

        // Month options
        // case 'This month':
        //     startDate = startOfMonth(today);
        //     endDate = endOfMonth(today);
        //     break;

        case 'Month to date':
            startDate = startOfMonth(today);
            endDate = today;
            break;

        case 'Previous month':
            const prevMonth = subMonths(today, 1);
            startDate = startOfMonth(prevMonth);
            endDate = endOfMonth(prevMonth);
            break;

        case 'Last 30 days':
            startDate = subDays(today, 30);
            endDate = today;
            break;

        // Quarter options
        // case 'This quarter':
        //     startDate = startOfQuarter(today);
        //     endDate = endOfQuarter(today);
        //     break;

        case 'Quarter to date':
            startDate = startOfQuarter(today);
            endDate = today;
            break;

        case 'Previous quarter':
            const prevQuarter = subQuarters(today, 1);
            startDate = startOfQuarter(prevQuarter);
            endDate = endOfQuarter(prevQuarter);
            break;

        case 'Last 90 days':
            startDate = subDays(today, 90);
            endDate = today;
            break;

        // Year options
        // case 'This year':
        //     startDate = startOfYear(today);
        //     endDate = endOfYear(today);
        //     break;

        case 'Last 6 months':
            startDate = subMonths(today, 6);
            endDate = today;
            break;

        case 'Last 12 months':
            startDate = subMonths(today, 12);
            endDate = today;
            break;

        case 'Year to date':
            startDate = startOfYear(today);
            endDate = today;
            break;

        default:
            startDate = today;
            endDate = today;
    }

    return {
        startDate: format(startDate, 'yyyy-MM-dd'),
        endDate: format(endDate, 'yyyy-MM-dd')
    };
};
